import React from 'react';
import { Button, Form } from 'react-bootstrap';
import OtpInput from 'react18-input-otp';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import Mobile from '../Assets/mobile.png';

function VerifyOtp(props) {
  const { oneTimePassword, handleSubmit, formValues, otpResendSeconds, handleResendOTP, loading, setOneTimePassword } =
    props;

  return (
    <Form onSubmit={handleSubmit}>
      <div className="text-center mb-4">
        <img src={Mobile} className="img-fluid" alt="mobile" />
      </div>
      <h2 className="text-center mb-4">Verify OTP</h2>
      <div className="text-center mb-4">
        <p className="mb-0 fs-6">We have sent you an OTP on</p>
        <p className="base-color fw-bold fs-5">{formValues.mobile}</p>
      </div>
      <div className="otp-inputs mb-4">
        <OtpInput
          value={oneTimePassword}
          onChange={(otp) => {
            setOneTimePassword(otp);
          }}
          shouldAutoFocus={true}
          numInputs={6}
          isInputNum={true}
          separator={<span className="mx-2 d-md-inline-block d-none">-</span>}
        />
      </div>

      <div className="text-center mb-4">
        {otpResendSeconds === 0 ? (
          <Button variant="link" className="text-decoration-none" onClick={handleResendOTP}>
            <RefreshIcon className="me-1" />
            Resend OTP
          </Button>
        ) : (
          <p className="text-muted">Resend OTP in {otpResendSeconds.toString().padStart(2, '0')} sec</p>
        )}
      </div>
      <div className="d-grid">
        <Button
          type="submit"
          className="login-btn base-color-bg text-white fw-semibold px-5"
          size="lg"
          onSubmit={handleSubmit}
          disabled={oneTimePassword?.length !== 6 || loading}
        >
          {loading ? 'Verifying...' : 'Verify OTP'}
        </Button>
      </div>
    </Form>
  );
}

export default VerifyOtp;
